import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var fontSizes = (function (overrides) {
  return _objectSpread({
    100: 0.75,
    150: 0.875,
    200: 1,
    300: 1.25,
    400: 1.5,
    500: 2,
    600: 2.5,
    700: 3,
    800: 3.75,
    900: 4.5
  }, _get(overrides, 'fontSizes', {}));
});

export default fontSizes;
